import React from 'react';
import { CircleHelp } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';
import { useHelp } from './HelpContext';
import './help.css';

/**
 * The one way into help: a ? button in every header (the app bar, the Admin
 * Center, the event, course and Learning hub top bars). A small dot means What's
 * new has something this person has not seen.
 *
 * `className` lets each header give it the same size as its other icon buttons.
 */
export default function HelpButton({ className = '' }: { className?: string }) {
  const { t } = useI18n();
  const help = useHelp();
  if (!help || !help.meta.user) return null;
  const { open, unreadCount } = help.state;
  const label = unreadCount > 0 ? t('help.buttonUnread', { count: unreadCount }) : t('help.button');
  return (
    <button
      type="button"
      className={`khelp-trigger${open ? ' khelp-trigger--open' : ''}${className ? ` ${className}` : ''}`}
      onClick={help.actions.togglePanel}
      aria-label={label}
      aria-expanded={open}
      aria-controls="khelp-panel"
      aria-keyshortcuts="Shift+/"
      title={t('help.buttonTitle')}
      data-help-button=""
      data-tour="help-button"
    >
      <CircleHelp size={20} aria-hidden="true" />
      {unreadCount > 0 && <span className="khelp-trigger__dot" aria-hidden="true" />}
    </button>
  );
}
